import { useContext, useEffect } from 'react';

import {
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  IconButton,
  Tooltip,
  styled,
  useTheme,
  Button
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../../reduxServer/slices/themSlices";
import { RootState } from "../../../reduxServer/store";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import LightModeIcon from "@mui/icons-material/LightMode";
import { setLanguage } from "../../../reduxServer/slices/languageSlice";
import i18n from '../../../utils/rtl';


import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import HeaderMenu from './Menu';



function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();
const lang = useSelector((state:RootState) => state.language.lang);

  const dispatch = useDispatch();
  const mode = useSelector((state: RootState) => state.theme.mode);
    
  

  const handleThemeToggle = () => {
    dispatch(toggleTheme());
  };

   const changeLang = (lng) => {
    dispatch(setLanguage(lng));
    i18n.changeLanguage(lng);   // update i18next
  };
  
  const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
         ${lang === 'ar'
        ? `right: ${theme.sidebar.width}; left: 0;`
        : `left: ${theme.sidebar.width}; right: 0;`}
      width: auto;
    }
`
);

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
              lighten(theme.colors.primary.main, 0.7),
              0.15
            )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
              theme.colors.alpha.black[100],
              0.2
            )}, 0px 5px 22px -4px ${alpha(
              theme.colors.alpha.black[100],
              0.1
            )}`
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        spacing={2}
      >
        {/* <HeaderMenu /> */}
          <Box sx={{ display: "flex", gap: "10px" }}>
      <Button 
       onClick={() => changeLang("en")}
        disabled={lang === "en"}
        >English</Button>
      <Button 
      onClick={() => changeLang("ar")}
        disabled={lang === "ar"}
      >العربية</Button>
    </Box>
        
      </Stack>
      <Box display="flex" alignItems="center">
        <IconButton color="primary" onClick={handleThemeToggle}>
          {mode === "light" ? <Brightness4Icon /> : <LightModeIcon />}
        </IconButton>
        {/* <HeaderButtons /> */}
        <HeaderUserbox />
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
